import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/pages/home";
import Plan from "./components/pages/home/Plan";
import Research from "./components/pages/home/Research";
import Casestudy from "./components/pages/home/Casestudy";
import ResearchInside from "./components/pages/research/ResearchInside";
import StudyReveals from "./components/pages/research/StudyReveals";
import GeneticRisk from "./components/pages/research/GeneticRisk";
import GeneticResearch from "./components/pages/research/GeneticResearch";
import StudyRevealsRunning from "./components/pages/research/StudyRevealsRunning";
import StudyRevealsCorrelation from "./components/pages/research/StudyRevealsCorrelation";
import StudyRevealsGenetic from "./components/pages/research/StudyRevealsGenetic";
import ScrollZoomVideo from "./components/pages/ScrollZoomVideo";
// import { initLenis } from "./components/pages/home/lenis";

import "primereact/resources/themes/lara-light-blue/theme.css"; // or any theme you like
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

function App() {
  // useEffect(() => {
  //   initLenis();
  // }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/testing" element={<ScrollZoomVideo />} />
        <Route path="/" element={<Home />} />
        <Route path="/plan" element={<Plan />} />
        <Route path="/research" element={<Research />} />
        <Route path="/casestudies" element={<Casestudy />} />
        <Route path="/research/genetic-link" element={<ResearchInside />} />
        <Route path="/research/study-reveals" element={<StudyReveals />} />
        <Route path="/research/genetic-risk" element={<GeneticRisk />} />
        <Route path="/research/genetic-research" element={<GeneticResearch />} />
        <Route path="/research/study-reveals-running" element={<StudyRevealsRunning />} />
        <Route path="/research/study-reveals-correlation" element={<StudyRevealsCorrelation />} />
        <Route path="/research/study-reveals-genetic" element={<StudyRevealsGenetic />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
